import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { trackLead, trackConversion } from '../utils/analytics';
import { ImageWithFallback } from './ImageWithFallback';

interface Service {
  id: string;
  slug: string;
  title: string;
  description?: string;
  image?: string;
  features?: string[];
}

interface ServiceCardProps {
  service: Service;
}

export function ServiceCard({ service }: ServiceCardProps) {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    // Track service click
    trackLead('service_click', {
      service_slug: service.slug,
      title: service.title
    });
  };

  return (
    <div
      className={`bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 ${
        isHovered ? 'shadow-xl transform -translate-y-1' : ''
      }`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    >
      {service.image_url && (
        <ImageWithFallback
          src={service.image_url}
          alt={service.title}
          className="w-full h-48"
          sizes="(min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw"
        />
      )}
      <div className="p-6">
        <h3 className="text-xl font-semibold text-gray-900">{service.title}</h3>
        {service.description && (
          <p className="mt-2 text-gray-600">{service.description}</p>
        )}
        {service.features && service.features.length > 0 && (
          <ul className="mt-4 space-y-2">
            {service.features.map((feature, index) => (
              <li 
                key={index} 
                className="flex items-center text-gray-600 transition-colors duration-200 hover:text-gray-900"
              >
                <Check className="w-5 h-5 text-green-500 mr-2" />
                {feature}
              </li>
            ))}
          </ul>
        )}
        <div className={`mt-4 text-blue-600 font-medium transition-opacity duration-300 ${
          isHovered ? 'opacity-100' : 'opacity-0'
        }`}>
          Learn More →
        </div>
      </div>
    </div>
  );
}